// export { default as chainsDetail } from "./chainsDetail/chainsDetail.vue";
export const chainsDetail = (r) => require.ensure([], () => r(require("./chainsDetail/chainsDetail.vue")), "chainsDetail");
